import { LogEventNames } from '../interfaces/ITelemetryLogger';
import { HostAppName } from '../office-js/HostAppSettings';
import { HostAppUtil } from '../office-js/HostAppUtil';
import { LogError } from '../../utils/ErrorTelemetry';
import { OneNoteEventNotifier } from '../OneNote/OneNoteEventNotifier';
import { IEventNotifier } from '../interfaces/IEventNotifier';

export const InitializeHostAppNotifer = () : IEventNotifier | undefined => {
  const hostAppName = HostAppUtil.GetHostAppName();
  switch (hostAppName) {
    case HostAppName.ONENOTE:
      return new OneNoteEventNotifier();
      break;
    default:
      LogError(LogEventNames.Warning, "Requested Host App Notifier for current app name is not supported");
      return undefined;
  }
}
